export default __webpack_public_path__ + "static/media/stkSSAP.50ff871d.svg";